import { render } from "./SelectionList.vue?vue&type=template&id=8e23360a&scoped=true&ts=true"
import script from "./SelectionList.vue?vue&type=script&lang=ts"
export * from "./SelectionList.vue?vue&type=script&lang=ts"

import "./SelectionList.vue?vue&type=style&index=0&id=8e23360a&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/apps/builder-legacy/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e23360a"]])

export default __exports__